import React, { useState, useEffect, useRef } from 'react';
import { heroVideos, businessInfo } from '../mock/data';
import ContactButtons from './ContactButtons';
import { ChevronDown } from 'lucide-react';

const VideoHero = () => {
  const [currentVideoIndex, setCurrentVideoIndex] = useState(0);
  const videoRefs = useRef([]);

  useEffect(() => {
    // Aktif videoyu oynat
    const currentVideo = videoRefs.current[currentVideoIndex];
    if (currentVideo) {
      currentVideo.play().catch((error) => {
        console.log('Video autoplay engellendi:', error);
      });
    }
  }, [currentVideoIndex]);

  const handleVideoEnd = () => {
    // Video bittiğinde bir sonraki videoya geç
    setCurrentVideoIndex((prev) => (prev + 1) % heroVideos.length);
  };

  const scrollToContent = () => {
    window.scrollTo({
      top: window.innerHeight,
      behavior: 'smooth'
    });
  };

  return (
    <section className="relative h-screen w-full overflow-hidden video-bg">
      {/* Video Background with Smooth Transition */}
      {heroVideos.map((video, index) => (
        <video
          key={index}
          ref={(el) => (videoRefs.current[index] = el)}
          src={video}
          autoPlay={index === currentVideoIndex}
          muted
          playsInline
          onEnded={handleVideoEnd}
          className={`absolute top-0 left-0 w-full h-full object-cover transition-opacity duration-1000 ${
            index === currentVideoIndex ? 'opacity-100' : 'opacity-0'
          }`}
        />
      ))}

      {/* Overlay - %25 daha açık */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/25 to-black/45 z-[1]" />

      {/* Content */}
      <div className="relative z-10 h-full flex items-center justify-center">
        <div className="container mx-auto px-4">
          <div className="text-center space-y-8 fade-in">
            {/* Logo */}
            <div className="flex justify-center mb-6">
              <img
                src={businessInfo.logo}
                alt={businessInfo.name}
                className="h-32 md:h-40 w-auto object-contain drop-shadow-2xl animate-in zoom-in duration-700"
              />
            </div>

            {/* Heading */}
            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold font-['Playfair_Display'] gold-gradient-text leading-tight">
              Crocus Hamam Spa
            </h1>

            {/* Subtitle */}
            <p className="text-xl md:text-2xl text-gray-300 max-w-3xl mx-auto leading-relaxed">
              Geleneksel Türk Hamamı ve Profesyonel Masaj Hizmetleri
            </p>

            <p className="text-base md:text-lg text-[var(--gold-light)] font-medium">
              Bostancı Marmaray Durağı Karşısı, Bostancı / Kadıköy / İstanbul
            </p>

            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-8">
              <ContactButtons />
            </div>

            {/* Video Indicator */}
            <div className="flex items-center justify-center space-x-2 mt-8">
              {heroVideos.map((_, index) => (
                <button
                  key={index}
                  onClick={() => setCurrentVideoIndex(index)}
                  className={`h-2 rounded-full transition-all duration-300 ${
                    index === currentVideoIndex
                      ? 'w-8 bg-[var(--gold)]'
                      : 'w-2 bg-gray-500 hover:bg-[var(--gold-dark)]'
                  }`}
                  aria-label={`Video ${index + 1}`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <button
        onClick={scrollToContent}
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 z-10 text-[var(--gold)] animate-bounce cursor-pointer hover:text-[var(--gold-light)] transition-colors duration-300"
        aria-label="Aşağı kaydır"
      >
        <ChevronDown size={40} />
      </button>
    </section>
  );
};

export default VideoHero;